import styled from "styled-components";
import { formatBRL } from "./format";

const Root = styled.span`
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  color: ${({ theme, $isNegative }) => ($isNegative ? theme.colors.E400 : "inherit")};
`;

/**
 * Valor em reais ("R$ 8.500,00"): números tabulares, negativo em E400 com sinal.
 * Aceita número ou o texto da API ("5200.00"); sem valor mostra "—".
 * `currency={false}` esconde o "R$" (colunas que já dizem a moeda no cabeçalho).
 */
export default function Money({ value, currency = true, className }) {
  const text = formatBRL(value);
  const isNegative = text.startsWith("-");
  return (
    <Root className={className} $isNegative={isNegative}>
      {currency || text === "—" ? text : text.replace(/R\$\s*/, "")}
    </Root>
  );
}
